import { render, staticRenderFns } from "./awardInfo.vue?vue&type=template&id=8dff0488&"
import script from "./awardInfo.vue?vue&type=script&lang=js&"
export * from "./awardInfo.vue?vue&type=script&lang=js&"
import style0 from "./awardInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports